/* eslint-disable react/no-danger */
/* eslint-disable jam3/no-sanitizer-with-danger */
import React, { ReactElement } from 'react';

import { sanitizeHTML } from '@/lib/util';

interface SystemRequirementPropsType {
  isVisible: boolean;
  content: string;
  classNamePrefix: string;
}

const SystemRequirement = ({
  isVisible,
  content,
  classNamePrefix,
}: SystemRequirementPropsType): ReactElement => {
  const systemContent = sanitizeHTML(content) as unknown as string;

  return (
    <div
      className={`${classNamePrefix}__system-req ${
        isVisible ? 'is-visible' : ''
      }`}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: systemContent,
        }}
      />
    </div>
  );
};

export default SystemRequirement;
